import { darkTheme as iDarkTheme, theme as iLightTheme, ThemeProvider as IntelieThemeProvider } from '@intelie/ui'
import React, { ComponentType, useContext } from 'react'
import { createGlobalStyle, DefaultTheme, useTheme } from 'styled-components'

import { DashboardContext } from 'live/context/dashboard'
import liveTheme from 'live/services/theme'

const lightTheme = { ...liveTheme, ...iLightTheme, name: 'light' }
const darkTheme = { ...liveTheme, ...iDarkTheme, name: 'dark' }

export const themes = [lightTheme, darkTheme]

export const GlobalStyles = createGlobalStyle<{ cssVarsSelector: string }>`
    ${({ cssVarsSelector }) => cssVarsSelector} {
        color: var(--gray-800);
        
        input[type="email"], input[type="number"], input[type="password"], input[type="text"], select, textarea {
            background-color: var(--gray-0);
            color: var(--gray-800);
        }
    }

   
`

export function themeAwardWidgetDecorator<P>(
    Component: ComponentType<P>,
    cssVarsSelector = '.widget-content-container'
): ComponentType<P> {
    return function ThemeAwareTree(props: P): JSX.Element {
        const theme = useTheme() as DefaultTheme & Record<string, unknown>
        const dashboardContext = useContext(DashboardContext)

        // when dark mode
        if (dashboardContext.theme === 'dark') {
            // if theme exists and it is dark
            // means Live is already configured in dark theme
            if (theme['gray-100'] && theme.themeName === 'dark') {
                return (
                    <IntelieThemeProvider theme={theme} cssVarsSelector={cssVarsSelector}>
                        <Component {...props} />
                    </IntelieThemeProvider>
                )
            }

            return (
                <IntelieThemeProvider theme={darkTheme} cssVarsSelector={cssVarsSelector}>
                    <Component {...props} />
                    <GlobalStyles cssVarsSelector={cssVarsSelector} />
                </IntelieThemeProvider>
            )
        }

        // if theme is being provided, just use it
        if (theme?.['gray-100']) {
            return (
                <IntelieThemeProvider theme={theme} cssVarsSelector={cssVarsSelector}>
                    <Component {...props} />
                    <GlobalStyles cssVarsSelector={cssVarsSelector} />
                </IntelieThemeProvider>
            )
        }

        return (
            <IntelieThemeProvider theme={lightTheme} cssVarsSelector={cssVarsSelector}>
                <Component {...props} />
                <GlobalStyles cssVarsSelector={cssVarsSelector} />
            </IntelieThemeProvider>
        )
    }
}
